import React from 'react';
import { Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PromoBanner: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative bg-gradient-to-r from-purple-600/20 to-pink-600/20 rounded-xl border border-purple-500/30 p-6 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-transparent"></div>
      <div className="relative z-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center space-x-2 mb-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <h3 className="text-2xl font-bold text-white">Kuruluşumuza Geçerli Özel İndirim!</h3>
            </div>
            <p className="text-gray-300 mb-4">
              TBKMeet Pro planında geçerli %40 indirim ile 2026'da üretkenliğinizi bir üst seviyeye taşıyın. 
              Daha uzun toplantılar, sınırsız özellikler, 10 GB Bulut Depolama ve çok daha fazlası sizin olsun.
            </p>
            <button
              onClick={() => navigate('/pricing')}
              className="px-6 py-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 transition transform hover:scale-105"
            >
              Hemen Faydalan
            </button>
            <p className="text-gray-400 text-xs mt-2">Şartlar geçerlidir.</p>
          </div>
          <div className="hidden md:flex flex-shrink-0 items-center justify-center">
            <div className="relative w-32 h-32 rounded-full p-1 bg-gradient-to-br from-purple-400/40 to-pink-400/40 ring-2 ring-purple-400/20">
              <img
                src="/images/dashboard/promo-pro-discount.png"
                alt="TBKMeet Pro tanıtım görseli"
                className="w-full h-full rounded-full object-cover shadow-lg shadow-purple-500/30"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
